// New-tournament form: the handicap % and each golfer's tees only matter for
// Course handicaps (Index uses a fixed 90% and ignores tees), and tee
// adjustments only for Index. Each shows only while its method is selected
// and is disabled otherwise -- a disabled field isn't submitted, so it keeps
// the column default (90%, championship tees, no adjustment). Without JS
// everything shows and submits.
const TournamentForm = {
  init() {
    const method = document.querySelector('[data-handicap-method]');
    if (!method || method.dataset.formReady === 'true') return;
    method.dataset.formReady = 'true';
    const apply = () => {
      const course = method.value === 'use_course_handicap';
      document.querySelectorAll('[data-course-only], [data-index-only]').forEach((el) => {
        const show = el.hasAttribute('data-course-only') ? course : !course;
        el.classList.toggle('hidden', !show);
        el.querySelectorAll('select, input').forEach((field) => { field.disabled = !show; });
      });
    };
    method.addEventListener('change', apply);
    apply();
  }
};

document.addEventListener('turbolinks:load', TournamentForm.init);
document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('[data-handicap-method]').forEach((el) => delete el.dataset.formReady);
});

export default TournamentForm;
